const routes = [
  {
    path: '/huinong',
    name: 'huinong',
    component: () => import('@/views/hui-xiao-nong/HuiXiaoNong.vue'),
    meta: {
      title: '惠小农',
    },
  },
];
export default routes;
